const handleAddMoreItemsToCart = async (formData) => {
  const formDataInput = new FormData();
  formDataInput.append('action', 'addMoreItemsInCart');
  formDataInput.append('inputs', JSON.stringify(formData));
  try {
    const response = await axios.post(localData.apiURL, formDataInput);
    openCartPopupOnAddSuccess(response.data.data.cart_content_html);
    // GA4 add_to_cart (sestavine recepta)
    if (response.data.data.add_to_cart) window.prowDL.pushEcommerce('add_to_cart', response.data.data.add_to_cart.ecommerce);
    updateCartNumber(response.data.data.cart_contents_count);
  } catch (err) {
    console.error(err);
  }
};

attachEvent('.ingredient-calculator__footer a', 'click', (ev) => {
  ev.preventDefault();
  const addToCartData = [...document.querySelectorAll('.ingredient-calculator__list .product-small-card')].map(
    (item) => ({
      product_id: item.dataset.productId,
      quantity: item.querySelector('.quantity-counter__input').value || 1,
    }),
  );
  handleAddMoreItemsToCart(addToCartData);
});
